import script from "./ProviderProfileSlideOver.vue?vue&type=script&setup=true&lang=js"
export * from "./ProviderProfileSlideOver.vue?vue&type=script&setup=true&lang=js"

import "./ProviderProfileSlideOver.vue?vue&type=style&index=0&id=4f66bf96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f66bf96"]])

export default __exports__